module.exports = __webpack_public_path__ + "78f5a6403fab78d81c5cd7a16831bf32.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-420.webp.png
// module id = 346
// module chunks = 0